<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 09:23:25
 * @LastEditors: yd
 * @LastEditTime: 2020-10-24 18:18:10
-->
<template>
  <div>
    <mrc_ess_table
      v-if="$route.name == 'systemParameter'"
      :headers="headers"
      pageName="addSystemParameter"
      :paginationOptions="options"
      :hideAddBtn="!hasBtn('add-system-configuration')"
      @turnPage="getlist"
      :isLoading="loading"
      :slotKey="['param_name']"
      :items="desserts"
    >
      <template v-slot:search>
        <v-row
          class="d-flex justify-end"
          style="background: white;
          margin: 0;
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;padding: 0 16px"
        >
          <mrc_ess_advanceFilterAndSearchInput
            class="mt-4"
            v-model="systemSeniorQueryString"
            @success="getlist({ cpage: 1 })"
            :systemFieldMeta="systemFieldMeta"
          ></mrc_ess_advanceFilterAndSearchInput>
        </v-row>
      </template>
      <template #item.param_name="{item}">
        {{ INT(item.param_name) }}
      </template>

      <!-- 状态 -->
      <!-- <template v-slot:item.status='{item}'>
        <mrc_ess_viewbtn :is_used='item.status'></mrc_ess_viewbtn>
      </template> -->

      <!-- 操作 -->
      <template v-slot:item.actions="{ item }">
        <menu-list :list="menulist" @handleClick="handleClick($event, item)">
          <template v-slot:showAction>
            <v-icon
              v-btnAuth="[
                'view-system-configuration',
                'edit-system-configuration',
                'delete-system-configuration',
              ]"
              >mdi-dots-vertical</v-icon
            >
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import {
  getSystemParameterList,
  detailSystemParameter,
  addSystemParameter,
  updateSystemParameter,
  deleteSystemParameter,
} from "@/service/api/systemParameter.js"
export default {
  components: {},
  props: {},
  data() {
    return {
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      disabled: true,
      list: {},
      options: {
        pagesize: this.$store.state.pageSize, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
      },
      loading: false,
      desserts: [],
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("label_The_parameter_name"),
          align: "start",
          value: "param_name",
          sortable: false,
        },
        {
          text: this.$t("label_Parameters_of_the_key_name"),
          value: "param_key",
          sortable: false,
        },
        {
          text: this.$t("label_value"),
          value: "param_key_value",
          sortable: false,
        },
        {
          text: this.$t("label_type"),
          value: "business_type",
          sortable: false,
        },
        { text: "", value: "actions", sortable: false, align: "end" },
      ]
    },
    menulist() {
      return [
        {
          name: this.$t("label_View"),
          show: this.hasBtn("view-system-configuration"),
          type: "view",
        },
        {
          name: this.$t("label_Edit"),
          show: this.hasBtn("edit-system-configuration"),
          type: "edit",
        },
        {
          name: this.$t("label_delete"),
          show: this.hasBtn("delete-system-configuration"),
          type: "del",
        },
      ]
    },
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1)
  },
  async created() {
    await this.getBtnPermissionList()
  },
  watch: {
    $route(v) {
      if (v.name == "systemParameter") {
        this.getlist()
      }
    },
  },
  async mounted() {
    await this.getlist()
  },
  beforeDestroy() {},
  methods: {
    async getlist(obj) {
      this.loading = true
      if (this.desserts.length == 1 && this.options.cpage != 1)
        this.options.cpage--
      if (obj) {
        const { cpage, pagesize } = obj
        this.options = { ...this.options, ...obj }
      }
      const res = await getSystemParameterList({
        pindex: this.options.cpage,
        psize: this.options.pagesize,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      })
      if (res.code == 200) {
        this.desserts = res.data
        this.options.totalcount = res.totalcount
        this.options.totalpage = res.totalpage
        this.systemFieldMeta = res.systemFieldMeta
        this.field_alias_name = res.field_alias_name
        this.table_alias_name = res.table_alias_name
      }
      this.loading = false
    },
    godetail(item) {
      this.$store.commit("set_iconstatus", true) //行内进图标显示
      this.$store.commit("set_subPage_name", item.param_name)
      this.$store.commit("set_uuid", item.uuid) //
      this.$router.push({
        name: "detailSystemParameter",
      })
    },
    handleClick({ item }, obj) {
      switch (item.type) {
        case "view":
          this.godetail(obj)
          break
        case "edit":
          this.$store.commit("set_subPage_name", obj.param_name)
          this.$store.commit("set_iconstatus", false) //行内进图标显示
          this.$store.commit("set_uuid", obj.uuid) //
          this.$router.push({
            name: "detailSystemParameter",
          })
          break
        case "del":
          this.$myConfirm({
            content: this.$t("message_Confirm_the_deletion"),
          }).then((res) => {
            deleteSystemParameter({ uuid: obj.uuid }).then((res) => {
              if (res.code == 200) {
                this.$Message({
                  text: this.$t("message_The_deletion_was_successful"),
                })
                this.getlist()
              }
            })
          })
          break
      }
    },
    addemailtemplate() {
      this.$store.commit("set_subPage_name", "")
      this.$store.commit("set_uuid", "")
      this.$store.commit("set_iconstatus", "") //行内进图标显示
      this.$router.push({
        name: "addSystemParameter",
      })
    },
  },
}
</script>

<style scoped>
.cardtitle {
  position: relative;
}
.emailbtn {
  position: absolute;
  right: 70px;
  top: -50px;
}
</style>
